import { render, staticRenderFns } from "./PageHeadline.vue?vue&type=template&id=7ef55904&scoped=true&"
import script from "./PageHeadline.vue?vue&type=script&lang=ts&"
export * from "./PageHeadline.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeadline.vue?vue&type=style&index=0&id=7ef55904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef55904",
  null
  
)

export default component.exports